import {debounce, get, keys, map, reduce} from "lodash";
import './SignDocsStats.scss'
import React, {useContext, useEffect, useRef, useState} from "react";
import {getSignDocsStatistics, exportDashboardReportAsExcelAPI} from "../../../Services/api";
import {MultipleHorizontalValueBars} from "../MultiplHorizontalValueBars/MultipleHorizontalValueBars";
import {StatsWidgetWrapper} from "../StatsWidgetWrapper/StatsWidgetWrapper";
import {OrganizationFilter} from "../../../Utils/GridFilters/OrganizationFilter/OrganizationFilter";
import {useUserAdminOrgs} from "../../Hooks/UseUserAdminOrgs";
import {SignDocFilter} from "../../../Utils/GridFilters/SignDocFilter/SignDocFilter";
import {DashboardChartLabels, getSignDocOptions} from "./SignDocsStatsLib";
import {DoughnutChartLegend} from "../../Charts/DoughnutChartLegend/DoughnutChartLegend";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import {I18nReactContext} from "../../../contexts/I18nContext";
import {CompanyReactContext} from "../../../contexts/CompanyContext";
import {FeatureFlags, SignDocCategories} from "../../../Utils/Constants";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import {useNavigate} from 'react-router-dom';
import {Button} from "../../Form/Button/Button";

export const SignDocsStats = ({types, textType}) => {
    const {i18n} = useContext(I18nReactContext);
    const {featureFlags} = useContext(CompanyReactContext);
    const navigate = useNavigate();
    const [signDocStatisticsBySignDocId, setSignDocStatisticsBySignDocId] = useState()
    const [signDocStatisticsByOrganizationId, setSignDocStatisticsByOrganizationId] = useState()
    const [signDocCompleteStatusBySignDocId, setSignDocCompleteStatusBySignDocId] = useState()
    const [signDocCompleteStatusByOrganization, setSignDocCompleteStatusByOrganization] = useState()
    const [orgsFilterModel, setOrgsFilterModel] = useState({})
    const [signDocsFilterModel, setSignDocsFilterModel] = useState({})
    const [signDocCount, setSignDocCount] = useState(0)
    const [usersCount, setUsersCount] = useState(0)
    const [usersWithActiveTask, setUsersWithActiveTask] = useState(0)
    const [allSignDocsOfACompanyCount, setAllSignDocsOfACompanyCount] = useState(0)
    const [isLoading, setIsLoading] = useState(true)
    const [isExporting, setIsExporting] = useState(false)
    const [organizationExamsStats, setOrganizationExamsStats] = useState(null)
    const [exmasStatistics, setExmasStatistics] = useState()
    const {adminOrganizationOptions, adminOrganizations, isOrgsLoading} = useUserAdminOrgs({
        withAllOption: true,
        withCoursesAndSignDocs: true
    })
    const SignDocCompleteStatusBySignDocId = () => {
        let tmpSignDocStatistics = map(keys(signDocStatisticsBySignDocId), (signDocId, index) => {
            const signDoc = signDocStatisticsBySignDocId[signDocId]
            signDoc.data = [signDoc.completed, signDoc.inProgress, signDoc.notStarted]
            signDoc.label = signDoc.docName
            signDoc.id = signDocId
            return signDoc
        })

        const newStatisticsData = map(keys(tmpSignDocStatistics), (signDocId, index) => {
            const signDoc = tmpSignDocStatistics[signDocId]
            return {
                barId: signDocId,
                barTitle: signDoc.docName,
                values: [
                    {
                        value: signDoc.completed,
                        colorClass: 'colorYellow',
                        label: i18n.translate('ReportsPage.courseLegend.completed')
                    },
                    {
                        value: signDoc.inProgress,
                        colorClass: 'colorGrey',
                        label: i18n.translate('ReportsPage.courseLegend.inProgress')
                    },
                    {
                        value: signDoc.notStarted,
                        colorClass: 'colorLightGrey',
                        label: i18n.translate('ReportsPage.courseLegend.notStarted')
                    }
                ]
            }
        })
        setSignDocCompleteStatusBySignDocId(newStatisticsData)
    }

    const SignDocCompleteStatusByOrganization = () => {
        let tmpSignDocStatistics = map(keys(signDocStatisticsByOrganizationId), (organizationId, index) => {
            const organization = signDocStatisticsByOrganizationId[organizationId]
            organization.data = [organization.completed, organization.inProgress, organization.notStarted]
            organization.label = organization.organizationName
            organization.id = organizationId
            return organization
        })

        const newStatisticsData = map(keys(tmpSignDocStatistics), (organizationId, index) => {
            const organization = tmpSignDocStatistics[organizationId]
            return {
                barId: organizationId,
                barTitle: organization.organizationName,
                values: [
                    {
                        value: organization.completed,
                        colorClass: 'colorYellow',
                        label: i18n.translate('ReportsPage.courseLegend.completed')
                    },
                    {
                        value: organization.inProgress,
                        colorClass: 'colorGrey',
                        label: i18n.translate('ReportsPage.courseLegend.inProgress')
                    },
                    {
                        value: organization.notStarted,
                        colorClass: 'colorLightGrey',
                        label: i18n.translate('ReportsPage.courseLegend.notStarted')
                    }
                ]

            }
        })
        setSignDocCompleteStatusByOrganization(newStatisticsData)
    }
    const init = async ({orgsFilterModel, signDocsFilterModel}) => {
        const selectedOrgIds = get(orgsFilterModel, 'filterValues.organizationIds', []);
        if (selectedOrgIds.length > 0) {
            setIsLoading(true)
            let {
                signDocsByOrganization,
                signDocsBySignDoc,
                signDocCount,
                userCount,
                usersWithActiveTask,
                allSignDocsOfACompany,
                examsStats
            } = await getSignDocsStatistics({
                // types,
                organizationIds: selectedOrgIds,
                signDocIds: get(signDocsFilterModel, 'filterValues.signDocIds', ['all'])
            })
            setSignDocStatisticsBySignDocId(signDocsBySignDoc)
            setSignDocStatisticsByOrganizationId(signDocsByOrganization)
            setSignDocCount(signDocCount)
            setUsersCount(userCount)
            setUsersWithActiveTask(usersWithActiveTask)
            setAllSignDocsOfACompanyCount(get(allSignDocsOfACompany, 'length'))
            setOrganizationExamsStats(examsStats)
            setIsLoading(false)
        }
    }
    const debouncedInitRef = useRef(debounce(init, 500));

    useEffect(() => {
        if (adminOrganizationOptions) {
            // If admin has more than 20 organizations, default to first organization only
            const organizationCount = adminOrganizationOptions.length -1;

            let defaultValue = organizationCount >= 20 ? get(adminOrganizationOptions, '[1].value') : get(adminOrganizationOptions, '[0].value', 'all');

            setOrgsFilterModel({
                ...orgsFilterModel,
                filterData: {
                    ...orgsFilterModel.filterData,
                    organizations: adminOrganizationOptions
                },
                filterValues: {
                    ...orgsFilterModel.filterValues,
                    organizationIds: [defaultValue],
                }
            })
        }

    }, [adminOrganizationOptions])

    useEffect(() => {
        const {signDocOptionsTmp} = getSignDocOptions({
            selectedOrgOptions: get(orgsFilterModel, 'filterValues.organizationIds', []),
            adminOrganizations,
            categories: [SignDocCategories.FORCE_COMPLETION, SignDocCategories.CERTIFICATION],
            i18n
        })
        const tmpFilterModel = {
            ...signDocsFilterModel,
            filterData: {
                ...signDocsFilterModel.filterData,
                signDocs: signDocOptionsTmp
            },
            filterValues: {
                ...signDocsFilterModel.filterValues,
                signDocIds: [get(signDocOptionsTmp, '[0].value', 'all')]
            },
            signDocFilterKey: Math.floor(Math.random() * 10000) + 1
        }
        setSignDocsFilterModel(tmpFilterModel)
    }, [adminOrganizations, get(orgsFilterModel, 'filterValues.organizationIds'), get(orgsFilterModel, 'filterValues.organizationId')])

    useEffect(() => {
        debouncedInitRef.current({signDocsFilterModel, orgsFilterModel})
    }, [signDocsFilterModel]);

    useEffect(() => {
        SignDocCompleteStatusBySignDocId()
    }, [signDocStatisticsBySignDocId]);

    useEffect(() => {
        SignDocCompleteStatusByOrganization()
    }, [signDocStatisticsByOrganizationId]);

    useEffect(() => {
        getExamStatsBarData();
    }, [organizationExamsStats, signDocsFilterModel]);

    // Function to format exams data for MultipleHorizontalValueBars
    const getExamStatsBarData = () => {
        if (!organizationExamsStats || organizationExamsStats.length === 0) {
            setExmasStatistics([]);
            return;
        }

        const signDocId = get(signDocsFilterModel, 'filterValues.signDocIds[0]');

        // Filter the stats based on the selected exam if needed
        let filteredStats = [...organizationExamsStats]; // Create a copy to avoid modifying the original
        if (signDocId && signDocId !== 'all') {
            filteredStats = filteredStats.filter(exam => exam.examId === signDocId);
        }

        // Format the data for display
        const examStatsBarData = filteredStats.map(exam => ({
            barId: exam.examId,
            barTitle: exam.examName,
            values: [
                {
                    value: exam.usersPassed,
                    colorClass: 'colorYellow',
                    label: i18n.translate('ReportsPage.signDocStats.graphs.examPassCount')
                },
                {
                    value: exam.usersCompleted - exam.usersPassed,
                    colorClass: 'colorRed',
                    label: i18n.translate('ReportsPage.signDocStats.graphs.examFailCount')
                }
            ]
        }));

        // Update the state with the formatted data
        setExmasStatistics(examStatsBarData);
    };

    const handleExportToExcel = async () => {
        try {
            setIsExporting(true);

            // Extract current filter values
            const selectedOrgIds = get(orgsFilterModel, 'filterValues.organizationIds', []);
            const selectedSignDocIds = get(signDocsFilterModel, 'filterValues.signDocIds', ['all']);

            // Call API to generate Excel
            const result = await exportDashboardReportAsExcelAPI({
                organizationIds: selectedOrgIds,
                signDocIds: selectedSignDocIds
            });

            // Navigate to Generated Reports page on success
            if (result.status === 'completed') {
                navigate('/reports/generatedReports');
            } else {
                console.error('Export failed:', result.error);
            }
        } catch (error) {
            console.error('Error exporting dashboard report:', error);
        } finally {
            setIsExporting(false);
        }
    };

    return <div className="SignDocStats">
        <div className="filtersRow">
            {orgsFilterModel && orgsFilterModel.filterValues ?
                <OrganizationFilter 
                    filterModel={orgsFilterModel} 
                    setFilterModel={setOrgsFilterModel}
                    enableMultiSelect={true}
                    enableSelectAll={true}
                /> : ''}
            {signDocsFilterModel && signDocsFilterModel.filterValues ?
                <SignDocFilter key={signDocsFilterModel.signDocFilterKey} filterModel={signDocsFilterModel}
                               setFilterModel={setSignDocsFilterModel}/> : ''}
            <div className="legend">
                <DoughnutChartLegend
                    items={DashboardChartLabels({
                        i18n,
                        hasExamFeatureFlag: !!get(featureFlags, FeatureFlags.EXAM)
                    })}
                />
            </div>
            <div className="exportButton">
                <Button
                    text={i18n.translate('ReportsPage.signDocStats.exportToExcel')}
                    icon={<CloudDownloadIcon/>}
                    onClick={handleExportToExcel}
                    disabled={isExporting || isLoading}
                    loading={isExporting}
                    color="yellow"
                />
            </div>
        </div>
        {isLoading ? <LoadingSpinner/> : ''}
        <div className="row numberWidgetsRow">
            <div className="col-50 margin-left row">
                <div className="col-50 margin-left">
                    {usersCount ? <StatsWidgetWrapper
                        info={i18n.translate(`ReportsPage.signDocStats.graphs.info.usersCount`)}
                        bottomTitle={i18n.translate(`ReportsPage.signDocStats.graphs.usersCount`)}>
                        <div className="counter">
                            {reduce(usersCount, (sum, item) => 1 + sum, 0)}
                        </div>
                    </StatsWidgetWrapper> : ''}
                </div>
                <div className="col-50">
                    {allSignDocsOfACompanyCount ? <StatsWidgetWrapper
                        info={i18n.translate(`ReportsPage.signDocStats.graphs.info.allSignDocsOfACompanyCount`)}
                        bottomTitle={i18n.translate(`ReportsPage.signDocStats.graphs.allSignDocsOfACompanyCount`)}>
                        <div className="counter">
                            {allSignDocsOfACompanyCount}
                        </div>
                    </StatsWidgetWrapper> : ''}
                </div>
            </div>
            <div className="col-50 margin-right row">
                <div className="col-50 margin-left">
                    {usersWithActiveTask ? <StatsWidgetWrapper
                        info={i18n.translate(`ReportsPage.signDocStats.graphs.info.usersWithActiveTasks`)}
                        bottomTitle={i18n.translate(`ReportsPage.signDocStats.graphs.usersWithActiveTasks`)}>
                        <div className="counter">
                            {usersWithActiveTask}
                        </div>
                    </StatsWidgetWrapper> : ''}
                </div>
                <div className="col-50">
                    {signDocCount ? <StatsWidgetWrapper
                        info={i18n.translate(`ReportsPage.signDocStats.graphs.info.activeCourseCount`)}
                        bottomTitle={i18n.translate(`ReportsPage.signDocStats.graphs.activeCourseCount`)}>
                        <div className="counter">
                            {signDocCount}
                        </div>
                    </StatsWidgetWrapper> : ''}
                </div>
            </div>

        </div>
        <div className="statsWidgetsContainers">
            {signDocCompleteStatusBySignDocId && signDocCompleteStatusBySignDocId.length ?
                <div className="row widgetRow">

                    <div className="col-50 margin-left">
                        <StatsWidgetWrapper
                            title={i18n.translate(`ReportsPage.signDocStats.graphs.usersPerformancePercent`, {context: {}})}>
                            <MultipleHorizontalValueBars barsData={signDocCompleteStatusBySignDocId}
                                                         showPercent={true}/>
                        </StatsWidgetWrapper>
                    </div>
                    <div className="col-50 margin-right">
                        <StatsWidgetWrapper
                            title={i18n.translate(`ReportsPage.signDocStats.graphs.usersPerformanceNumbers`, {context: {}})}>
                            <MultipleHorizontalValueBars barsData={signDocCompleteStatusBySignDocId}
                                                         showPercent={false}/>
                        </StatsWidgetWrapper>
                    </div>
                </div> : ''}
            {signDocCompleteStatusByOrganization && signDocCompleteStatusByOrganization.length ?
                <div className="row widgetRow">

                    <div className="col-50 margin-left">
                        <StatsWidgetWrapper
                            info={i18n.translate(`ReportsPage.signDocStats.graphs.info.performancePercentByOrg`)}
                            title={i18n.translate(`ReportsPage.signDocStats.graphs.performancePercentByOrg`, {context: {orgsCount: get(signDocCompleteStatusByOrganization, 'length')}})}>
                            <MultipleHorizontalValueBars barsData={signDocCompleteStatusByOrganization}
                                                        showPercent={true}/>
                        </StatsWidgetWrapper>
                    </div>
                    <div className="col-50 margin-right">
                        <StatsWidgetWrapper
                            info={i18n.translate(`ReportsPage.signDocStats.graphs.info.performanceNumberByOrg`)}
                            title={i18n.translate(`ReportsPage.signDocStats.graphs.performanceNumberByOrg`, {context: {orgsCount: get(signDocCompleteStatusByOrganization, 'length')}})}>
                            <MultipleHorizontalValueBars barsData={signDocCompleteStatusByOrganization}
                                                        showPercent={false}/>
                        </StatsWidgetWrapper>
                    </div>
                </div> : ''}

            {/* Render exam statistics section */}
            {exmasStatistics && exmasStatistics.length > 0 && (
                <div className="row widgetRow">
                    <div className="col-50 margin-left">
                        <StatsWidgetWrapper
                            info={i18n.translate(`ReportsPage.signDocStats.graphs.info.examPassRate`)}
                            title={i18n.translate(`ReportsPage.signDocStats.graphs.examPassRate`)}
                        >
                            <MultipleHorizontalValueBars 
                                barsData={exmasStatistics}
                                showPercent={true}
                            />
                        </StatsWidgetWrapper>
                    </div>
                    <div className="col-50 margin-right">
                        <StatsWidgetWrapper
                            info={i18n.translate(`ReportsPage.signDocStats.graphs.info.examPassCountRate`)}
                            title={i18n.translate(`ReportsPage.signDocStats.graphs.examPassCountRate`                          )}>
                            <MultipleHorizontalValueBars 
                                barsData={exmasStatistics}
                                showPercent={false}
                            />
                        </StatsWidgetWrapper>
                    </div>
                </div>
            )}
        </div>
    </div>
}